// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// require('./stylesheets/application.scss');
//
import "@fortawesome/fontawesome-free"
import "./stylesheets/application.scss"
import { Turbo } from "@hotwired/turbo-rails"
import "admin-lte"
import './athena'
import './dropzone'
import 'lodash';
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

require("trix")
require("trix/dist/trix.css")
require("@rails/actiontext")
require("./trix-custom")

window.Stimulus = Application.start()
const context = require.context("../controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

Turbo.session.drive = false

// 監聽flashMessage，有錯誤訊息時自動 scroll 到頂部。
document.addEventListener('DOMContentLoaded', () => {
  const flashMessage = document.getElementById('flashMessage');
  if (!flashMessage) return;

  const observer = new MutationObserver(() => {
    if (flashMessage.querySelector('#errorMessage')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  observer.observe(flashMessage, { childList: true, subtree: true });
});
